import axios from 'axios';
import React, { useState } from 'react';
import '../assets/css/PollView.css';
import { baseurl } from '../utility/helper';

const PreTest = () => {
  const [formData, setFormData] = useState({
    chapter: '',
    title: '',
    description: '',
    venue: '',
    startTime: '',
    endTime: '',
    regStartDateTime: '',
    regEndDateTime: '',
    // fees: '',
    ageGroup: '',
    seat: '',
    note: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Clean up form data to ensure no empty strings are sent for timestamps
    // Log formData to debug
    console.log('Form Data:', formData);
    const cleanedFormData = {
      ...formData,
      startTime: formData.startTime ? formData.startTime : null,
      endTime: formData.endTime ? formData.endTime : null,
      regStartDateTime: formData.regStartDateTime ? formData.regStartDateTime : null,
      regEndDateTime: formData.regEndDateTime ? formData.regEndDateTime : null,
    };

    try {
      // Send a POST request to your API with formData
      const response = await axios.post(`${baseurl}/admin/tests`, cleanedFormData);

      // Handle successful response
      console.log('Form data successfully sent to the database:', response.data);

      // Optionally, you can reset the form or navigate the user to another page
      setFormData({
        chapter: '',
        title: '',
        description: '',
        venue: '',
        startTime: '',
        endTime: '',
        regStartDateTime: '',
        regEndDateTime: '',
        note: '',
        // fees: '',
        ageGroup: '',
        seat: ''
      });

    } catch (error) {
      // Handle error response
      console.error('Error sending form data to the database:', error);
    }
  };

  return (
    // <div className="page-wrapper">
    <div className="container mt-4">
      <form onSubmit={handleSubmit}>
        <div className="profile-section">
          <center><h3><b>Add Pre-Test</b></h3></center>
          <div className="col-md-12">
            <div className="row">
              <div className="col-md-6">
                <label htmlFor="chapter">Select Chapter:</label>
                <select
                  className="form-select"
                  id="chapter"
                  name="chapter"
                  value="1"
                  onChange={handleChange}
                  disabled
                >
                  <option value="1">PUNE</option>
                </select>
              </div>
              <div className="col-md-6">
                <label htmlFor="title">Test Title:</label>
                <input
                  type="text"
                  id="title"
                  name="title"
                  value={formData.title}
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-6" style={{ paddingTop: '20px' }}>
                <label htmlFor="description">Test Description:</label>
                <textarea
                  id="description"
                  className="form-control"
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-6" style={{ paddingTop: '20px' }}>
                <label htmlFor="venue">Test Venue:</label>
                <input
                  type="text"
                  id="venue"
                  name="venue"
                  value={formData.venue}
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-6" style={{ paddingTop: '20px' }}>
                <label htmlFor="startTime">Test Start Datetime:</label>
                <input
                  type="datetime-local"
                  className="form-control"
                  id="startTime"
                  name="startTime"
                  value={formData.startTime}
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-6" style={{ paddingTop: '20px' }}>
                <label htmlFor="endTime">Test End Datetime:</label>
                <input
                  type="datetime-local"
                  className="form-control"
                  id="endTime"
                  name="endTime"
                  value={formData.endTime}
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-6" style={{ paddingTop: '20px' }}>
                <label htmlFor="regStartDateTime">Registration Start Datetime:</label>
                <input
                  type="datetime-local"
                  className="form-control"
                  id="regStartDateTime"
                  name="regStartDateTime"
                  value={formData.regStartDateTime}
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-6" style={{ paddingTop: '20px' }}>
                <label htmlFor="regEndDateTime">Registration End Datetime:</label>
                <input
                  type="datetime-local"
                  className="form-control"
                  id="regEndDateTime"
                  name="regEndDateTime"
                  value={formData.regEndDateTime}
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-6" style={{ paddingTop: '20px' }}>
                <label htmlFor="ageGroup">Age Group:</label>
                <select
                  id="ageGroup"
                  name="ageGroup"
                  value={formData.ageGroup}
                  onChange={handleChange}
                  className="form-select"
                >
                  <option value="10-14.5">10 to 14.5 years</option>
                  <option value="14.5-99">14.5 to 99 years</option>
                </select>
              </div>
              <div className="col-md-6" style={{ paddingTop: '20px' }}>
                <label htmlFor="seat">Seat Capacity:</label>
                <select
                  id="seat"
                  name="seat"
                  value={formData.seat}
                  className="form-select"
                  onChange={handleChange}
                >
                  {[...Array(30)].map((_, index) => (
                    <option key={index + 1} value={index + 1}> {index + 1} </option>
                  ))}
                </select>
              </div>
              <div className="col-md-12" style={{ paddingTop: '20px' }}>
                <label htmlFor="note">Note:</label>
                <textarea
                  id="note"
                  className="form-control"
                  name="note"
                  value={formData.note}
                  onChange={handleChange}
                />
              </div>
              <center style={{ paddingTop: '20px' }}>
                <button type="submit">Submit</button>
              </center>
            </div>
          </div>
        </div>
      </form>
    </div>
    // </div>
  );
};

export default PreTest;
